// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/styles/client/carrouselStyle.scss
// module id = 2
// module chunks = 0